import { FormattedMessage, FormattedNumber } from '@liveauctioneers/hammer-ui-core/intl';
import { StarRating } from '@liveauctioneers/hammer-ui-core/starRating';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { memo } from 'react';
import isEqual from 'react-fast-compare';

import { SeeAllLink } from '../SeeAllLink/SeeAllLink';

type Props = {
    className?: string;
    hideReviewCount?: boolean;
    onClick?: (event: any) => void;
    rating: number;
    reviewCount?: number;
    small?: boolean;
    to?: string;
};

const RatingDisplaySmallComponent = ({
    className,
    hideReviewCount,
    onClick = null,
    rating,
    reviewCount,
    small,
    to,
}: Props) => {
    return rating >= 0 ? (
        <div
            className={cn(
                'flex flex-[1_1_auto] flex-row flex-wrap items-center gap-xs',
                {
                    'cursor-pointer': Boolean(onClick),
                    'cursor-default': !onClick,
                },
                className
            )}
            data-testid="symbolRatings"
            onClick={onClick}
        >
            <StarRating
                averageRating={rating}
                compact={small}
                emphasis="bold"
            />
            {!hideReviewCount && (
                <SeeAllLink
                    text={
                        <FormattedMessage
                            id="review.review_count"
                            values={{
                                count: (
                                    <FormattedNumber
                                        key="review_count"
                                        value={reviewCount}
                                    />
                                ),
                                reviewCount,
                            }}
                        />
                    }
                    url={to}
                />
            )}
        </div>
    ) : (
        <div>
            <span>N/A</span>
        </div>
    );
};

export const RatingDisplaySmall = memo<Props>(RatingDisplaySmallComponent, isEqual);
